export default (array) => array.sort((a, b) => {
  const entryA = a.sys ? a.sys.createdAt : a.createdAt;
  const entryB = b.sys ? b.sys.createdAt : b.createdAt;
  return entryA > entryB ? -1 : 1;
})